import { Button, DiscountCodeInput } from '@/components/atoms';
import { AvatarWithName, SummarySectionWithTitle } from '@/components/molecules';

interface PlayersRegistrationProps {
	userProfilePicture: string;
	firstName: string;
	lastName: string;
	registrationType: string;
	teamName: string;
	qty: number;
	price: number;
	players: { firstName: string; lastName: string }[];
}

export const PlayersRegistration = ({
	userProfilePicture,
	firstName,
	lastName,
	registrationType,
	teamName,
	qty,
	price,
	players
}: PlayersRegistrationProps) => {
	return (
		<div className="flex w-full max-w-[800px] flex-col rounded-xl bg-white p-4 shadow-md">
			<div className="flex items-center">
				<AvatarWithName src={userProfilePicture} alt={`${firstName} - profile picture`} firstName={firstName} lastName={lastName} />
			</div>

			<div className="flex flex-col gap-4">
				<SummarySectionWithTitle title="Summary">
					<div>
						<div className="flex flex-col text-sm font-semibold leading-5 text-gray-900 sm:h-10 sm:flex-row sm:items-center sm:justify-between">
							<span className="py-2.5">{registrationType}</span>

							<div>
								<span className="inline-block min-w-16 pl-0 text-left sm:p-2.5">Qty</span>
								<span className="inline-block min-w-20 p-2.5 text-left">Price</span>
								<span className="inline-block min-w-20 p-2.5 text-left">Total</span>
							</div>
						</div>

						<div className="flex flex-col text-gray-900 sm:h-10 sm:flex-row sm:items-center sm:justify-between">
							<span className="hidden h-10 py-2.5 text-base font-medium leading-6 sm:inline-block">{teamName}</span>

							<div className="">
								<span className="inline-block min-w-16 pl-0 text-left text-sm font-normal leading-5 sm:p-2.5">{qty}</span>
								<span className="inline-block min-w-20 p-2.5 text-left text-sm font-normal leading-5">${price}</span>
								<span className="inline-block min-w-20 p-2.5 text-left text-sm font-semibold leading-5">${qty * price}</span>
							</div>
						</div>

						<span className="mt-6 inline-block h-10 py-2.5 text-base font-medium leading-6 sm:hidden">{teamName}</span>
						{players.map((item, index) => {
							return (
								<div className="" key={index}>
									<p className="text-xs font-medium leading-[18px] text-gray-600">
										<span>
											{item.firstName} {item.lastName}
										</span>
									</p>
								</div>
							);
						})}
					</div>
				</SummarySectionWithTitle>

				<DiscountCodeInput />
			</div>

			<div className="mt-6 flex flex-col items-center justify-center">
				<span className="mb-3 text-xl font-semibold leading-[30px] text-gray-900">Remaining Balance</span>

				<div className="mb-8 flex items-center justify-center gap-1">
					<span className="text-sm font-normal leading-5 text-gray-400">USD</span>
					<span className="text-lg font-semibold not-italic leading-7 text-gray-900">${qty * price}</span>
				</div>

				<Button className="h-12 w-full max-w-[280px] bg-experiment px-5 py-3 text-base font-semibold leading-6 text-white sm:max-w-[332px]">
					Make a payment
				</Button>
			</div>
		</div>
	);
};
